module.exports = __webpack_public_path__ + "static/media/dogs.b1c6cbbb.jpg";